import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mobo-btn-check',
  templateUrl: './btn-check.component.html',
  styles: ``,
})
export class BtnCheckComponent {
  @Output() check = new EventEmitter();
  @Input() isSelected: boolean = false;

  public select() {
    this.isSelected = !this.isSelected;
    this.check.emit(this.isSelected);
  }
}
